import React from 'react'
import { PhotoProvider } from 'react-photo-view'
import { PhotoProviderProps } from 'react-photo-view/dist/PhotoProvider'

import ImageComponent, { ImageComponentProps } from 'components/image'

type PhotoViewGalleryProviderType = {
  children: React.ReactNode
} & PhotoProviderProps

const PHOTO_VIEW_MASK_OPACITY = 0.5

const PhotoViewGalleryProvider = ({
  children,
  maskOpacity = PHOTO_VIEW_MASK_OPACITY,
  ...props
}: PhotoViewGalleryProviderType) => {
  return (
    <PhotoProvider maskOpacity={maskOpacity} {...props}>
      {children}
    </PhotoProvider>
  )
}

// react-photo-view v1.2.4: to prevent warning, custom component wrapped inside PhotoView must have forwardRef
export const PhotoViewImageComponent = React.forwardRef(function CustomComponent(
  props: ImageComponentProps,
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  ref: React.Ref<HTMLImageElement>
) {
  return <ImageComponent {...props} />
})

export default PhotoViewGalleryProvider
